import CryptoJS from 'crypto-js';

const SECRET_KEY_BASE64 = process.env.REACT_APP_ENCRYPTION_KEY || '';
// if (!SECRET_KEY_BASE64) throw new Error('REACT_APP_ENCRYPTION_KEY is not set.');

export const aesEncrypt = (data) => {
  const key = CryptoJS.enc.Base64.parse(SECRET_KEY_BASE64);
  const iv = CryptoJS.lib.WordArray.random(16);
  const plaintext = typeof data === 'object' ? JSON.stringify(data) : String(data);

  const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  // Returns base64 of [IV][ciphertext]
  const ivAndCiphertext = iv.concat(encrypted.ciphertext);
  const base64String = CryptoJS.enc.Base64.stringify(ivAndCiphertext);
  
  // Convert to URL-safe Base64: replace '+' with '-', '/' with '_', and remove padding '='
  return base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
};

export const aesDecrypt = (payloadBase64) => {
  const key = CryptoJS.enc.Base64.parse(SECRET_KEY_BASE64);
  
  // Convert from URL-safe Base64 back to standard Base64
  // Replace '-' with '+', '_' with '/', and add padding if needed
  let standardBase64 = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
  
  // Add padding if needed (Base64 strings should be multiples of 4)
  while (standardBase64.length % 4) {
    standardBase64 += '=';
  }
  
  const encryptedBytes = CryptoJS.enc.Base64.parse(standardBase64);

  // First 16 bytes is IV (4 words x 4 bytes)
  const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4), 16);

  // Remaining bytes is ciphertext
  const ciphertext = CryptoJS.lib.WordArray.create(
    encryptedBytes.words.slice(4),
    encryptedBytes.sigBytes - 16
  );

  // Decrypt
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: ciphertext },
    key,
    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );
  try {
    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  } catch {
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
};